import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router'
import { useFormPageHandler, useMergeState } from '../../../irmlib/src/hooks'
import { FlexByRow, XDivider, YDivider, HalfScreen } from '../../../irmlib/src/styles'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import { Select, CancelButton, SaveButton, TextField } from '../../../irmlib/src/components/FormControls'
import TemplateFormat from './TemplateFormation'
import { setBusy, clearBusy, LocalToast, openGeneralDialog, closeGeneralDialog } from '../../../irmlib/src/containers'
import { ThemeButton, Label, OutlinedButton, ContainedButton, CheckBox, ToolTip } from '../../../irmlib/src/components/Controls'
import { DeleteOutlined, ArrowBack, Info } from '../../../irmlib/src/icons'
import * as constants from '../../../irmlib/src/common/constants'
import { useLocation } from 'react-router-dom'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import { validateAndGetAccountLevel2, validateAndGetAccountLevel3 } from '../../../services/skpApi'
import { templateSearch } from '../../../navigation/routePaths'
import { getUser } from '../../../redux/global'
import * as routePaths from '../../../navigation/routePaths'
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextareaAutosize } from '@material-ui/core'
import { isDataEntryUser, successToast } from '../../../common/functions'
import { useTranslation } from 'react-i18next'
import { reject } from 'lodash'

const minWidth = '100px'

const defaultSelectOption = { value: constants.defaultSelect, label: constants.defaultSelect }
const useStandardTemplate = 'useStandarrdTemplate'

const formTemplate = [
  {
    label: 'templates.country',
    fieldKey: 'country',
    isRequired: true,
  },
  {
    label: 'templates.associatedWMSSystem',
    fieldKey: 'associatedWMSSystem',
    isRequired: true,
  },
  {
    label: 'templates.accountLevelOne',
    fieldKey: 'accountLevel1',
    isRequired: true,
  },
  {
    label: 'templates.accountLevelTwo',
    fieldKey: 'accountLevel2',
  },
  {
    label: 'templates.accountLevelThree',
    fieldKey: 'accountLevel3',
  },
  {
    label: 'templates.templateType',
    fieldKey: 'dataEntryType',
    isRequired: true
  },
  {
    label: 'templates.templateName',
    fieldKey: 'templateName',
    isRequired: true,
  },
  {
    label: 'templates.templateName',
    fieldKey: 'templateName',
    isRequired: true,
    maxLength: 60
  },
  {
    label: 'templates.templateName',
    fieldKey: 'templateNameOld',
  },
  {
    label: 'templates.skpinstance',
    fieldKey: 'skpinstance',
  },
]

let title = ''

const VerticalDivider = () =>
  <YDivider height='20px' />

const BottomPaddedButton = props =>
  <>
    <ThemeButton style={{ minWidth: '100px' }} {...props} />
    <VerticalDivider />
  </>

const getService = async () => {
  const getObject = {
    obj: {
      obj1: {

      }
    }
  }
  return Promise.resolve(getObject)
}

const SELECT_COUNTRY = 0
const SELECT_WMS = 1
const SELECT_ACOUNT_LEVEL1 = 2
const SELECT_ACOUNT_LEVEL2 = 3
const SELECT_ACOUNT_LEVEL3 = 4
const SELECT_TEMPLATE_TYPE = 5
const SELECT_TEMPLATE_NAME = 6
const FIELD_CUSTOM_TEMPLATE_NAME = 7
const FIELD_CUSTOM_TEMPLATE_NAME_OLD = 8
const SKP_INSTANCE = 9

const initialSate = {
  showTable: false,
  showPreview: false,
  countryList: [],
  wmsList: [],
  templateTypeList: [],
  templateNameList: [],
  accLevelOneList: [],
  accLevelTwoList: [],
  accLevelThreeList: [],
  templatesForSelect: [],
  skpInstance: [constants.defaultSelect],
  templates: [],
  templateInstructions: '',
  changeTemplateInstructions: '',
  existingTemplateInstructions: '',
  checkTemplateDeactivated: false,
  showDeactivateTemplateCheckBox: true,
  enableCheckBox: false,
  skpinstance: '',
  enableAddFieldsBtn: true,
  saveStandardTempValues: [],
  selectedTemplateFields: [],
  selectedTemplateFieldNames: [],
  openCustomFieldsDialog: false,
  addedCustomFields: [],
  isCustomFieldsAdded: false,
  fieldKey: '',
  skpEncoding: {}
}

const EditTemplate = () => {
  const refLocalBusyCursor = useRef(null)
  const [arrRefs, data] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })
  const [state, setState, getState] = useMergeState(initialSate)
  const tableRef = useRef(null)
  const [isNew, setIsNew] = useState(false)
  const refLocalToast = useRef(null)
  const [isTemplateDeactivated, setIsTemplateDeactivated] = useState(false)
  const [disableState, setDisableState] = useState(false)
  const location = useLocation()
  const templateId = location?.pathname.split('/')[2]
  const history = useHistory()
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    getTemplateDetail()
    if (history.location.state && (!history.location.state.isTitle && history.location.state.isTitle !== undefined)) {
      setDisableState(false)
      setState({ showDeactivateTemplateCheckBox: true })
    }
  }, [])

  const getTemplateDetail = async () => {
    setBusy()
    const templateDoc = await gdeTransactions.getTemplateById(templateId)
    const templateData = templateDoc.data()
    try {
      setState({ existingTemplateInstructions: templateData.templateInstructions })
    } catch {
      // console.log('no instructions')
    }
    let fieldKey = ''
    if ('templateName' in templateData) {
      fieldKey = 'templateName'
    } else {
      fieldKey = 'standardTemplateName'
    }
    setState({ fieldKey: fieldKey })
    // TODO: Remove this -> getUser().countryCode. Currently added for avoid error in old templates
    const countryCode = templateData?.countryCode || getUser().countryCode
    const countryDoc = await gdeTransactions.getCountryByID(countryCode)
    const countryData = countryDoc.data()

    const jobsForTemplate = await gdeTransactions.getJobsForTemplate(fieldKey, templateId)
    let requiredNew = false
    jobsForTemplate.forEach((doc) => {
      if ((doc.data().jobStatus === constants.jobStatus.inProgress || doc.data().jobStatus === constants.jobStatus.approved || doc.data().jobStatus === constants.jobStatus.transmitted)) {
        requiredNew = true
      }
    })
    setIsNew(requiredNew)


    const countryList = [{ value: countryDoc.id, label: `${countryDoc.id}-${countryData.countryName}` }]
    const wmsList = [{ value: templateData.wmsCode, label: templateData.wmsCode }]
    const skpInstance = [{ value: templateData.skpinstance ? templateData.skpinstance : constants.defaultSelect, label: templateData.skpinstance ? templateData.skpinstance : constants.defaultSelect }]
    const accLevelOneList = [{ value: templateData?.accountLevel1?.toUpperCase(), label: templateData?.accountLevel1?.toUpperCase() }]
    const accLevelTwoList = [{ value: templateData?.accountLevel2?.toUpperCase(), label: templateData?.accountLevel2?.toUpperCase() }]
    const accLevelThreeList = [{ value: templateData?.accountLevel3?.toUpperCase(), label: templateData?.accountLevel3?.toUpperCase() }]
    const templateTypeList = await getTemplateTypes(templateData.wmsCode)
    const [, , , , skpEncoding] = await gdeTransactions.getGdeConfig()
    // eslint-disable-next-line
    const isActive = templateData?.isActive === false ? false : true
    title = templateData.templateName

    setState({
      templateData: templateData,
      countryList: countryList,
      countryCode: countryCode,
      wmsList: wmsList,
      accLevelOneList: accLevelOneList,
      accLevelTwoList: accLevelTwoList,
      skpInstance: skpInstance,
      accLevelThreeList: accLevelThreeList,
      templateTypeList: templateTypeList,
      showTable: true,
      checkTemplateDeactivated: !isActive,
    })
    setState({ skpinstance: getState()?.skpInstance[0]?.value, skpEncoding: skpEncoding })
    setIsTemplateDeactivated(!isActive)

    // setting default values

    arrRefs[SELECT_COUNTRY].current.setValue(countryDoc.id)
    arrRefs[SELECT_WMS].current.setValue(templateData.wmsCode)
    arrRefs[SELECT_ACOUNT_LEVEL1].current.setValue(templateData?.accountLevel1?.toUpperCase())
    arrRefs[SELECT_ACOUNT_LEVEL2].current.setValue(templateData?.accountLevel2?.toUpperCase())
    arrRefs[SELECT_ACOUNT_LEVEL3].current.setValue(templateData?.accountLevel3?.toUpperCase())
    arrRefs[SKP_INSTANCE].current.setValue(templateData.skpinstance ? templateData.skpinstance : constants.defaultSelect)
    arrRefs[SELECT_TEMPLATE_TYPE].current.setValue(templateData.dataEntryType)
    arrRefs[SELECT_TEMPLATE_NAME].current.setValue(templateData.templateName)
    clearBusy()
  }

  const getTemplateTypes = async (wms) => {
    const collection = await gdeTransactions.getTemplateTypesForWms(wms)
    const templateTypes = [defaultSelectOption]
    const standardTemplates = {}
    collection.forEach((doc) => {
      if (doc.data()?.assetType !== 'BOX TRANSMITTAL') {
        templateTypes.push({ value: doc.data().dataEntryType, label: doc.data().dataEntryType })
        standardTemplates[doc.data().dataEntryType] = doc.data()
      }
    })
    setState({ standardTemplates: standardTemplates })
    return templateTypes
  }

  const getTableData = async () => {
    if (title === getState().templateData.templateName) {
      let finalArrayFields
      const fields = getState().templateData.templateFields
      const arrayFields = Object.keys(fields).map((key) => {
        const data = fields[key]
        data.name = key
        return data
      })
      getState()?.renderNewTemplate ? (finalArrayFields = getState()?.addedCustomFields) : (finalArrayFields = arrayFields)
      finalArrayFields.sort((a, b) => (a.customOrder > b.customOrder) ? 1 : ((b.customOrder > a.customOrder) ? -1 : 0))
      setState({ selectedTemplateFields: finalArrayFields })
      return Promise.resolve(finalArrayFields)
    } else {
      let fields
      let finalArrayFields
      if (getState().selectedTemplate === useStandardTemplate) {
        fields = getState().standardTemplates[arrRefs[SELECT_TEMPLATE_TYPE].current.getValue()].templateFields
      } else {
        const template = await gdeTransactions.getTemplateById(title)
        fields = template.data().templateFields
      }
      const arrayFields = Object.keys(fields).map((key) => {
        const data = fields[key]
        data.name = key
        return data
      })
      getState()?.renderNewTemplate ? (finalArrayFields = getState()?.addedCustomFields) : (finalArrayFields = arrayFields)
      finalArrayFields.sort((a, b) => (a.customOrder > b.customOrder) ? 1 : ((b.customOrder > a.customOrder) ? -1 : 0))
      setState({ selectedTemplateFields: finalArrayFields })
      return Promise.resolve(finalArrayFields)
    }
  }
  const handleCancelButtonOnClick = () => {
    closeGeneralDialog()
    history.push(templateSearch)
  }

  const handleInstructionsSave = () => {
    setState({ changeTemplateInstructions: getState().templateInstructions || getState().existingTemplateInstructions })
    setTimeout(successToast({ message: t('toast.templateInstructionsSaved') }, 50000))
    closeGeneralDialog()
  }

  const ButtonsForCancelDialogBox = () =>
    <>
      <OutlinedButton id={'editTemplate_dialogBoxButton_no'} onClick={closeGeneralDialog} >buttons.no</OutlinedButton>
      <ContainedButton id={'editTemplate_dialogBoxButton_yes'} onClick={handleCancelButtonOnClick} >buttons.yes</ContainedButton>
    </>

  const handleCancel = () => {
    openGeneralDialog({
      title: t('options.cancelTemplateTitle'),
      message: t('options.cancelJobMessage'),
      noTranslateTitle: true,
      noTranslateMessage: true,
      buttons: <ButtonsForCancelDialogBox />,
      closeX: true
    })
  }

  const Buttons = props =>
    <>
      <CancelButton id={'editTemplate_button_cancel'} arrRefs={props.arrRefs} onClick={handleCancel} />
      <XDivider width='10px' />
      <BottomPaddedButton id={'editTemplate_button_save'} variant='contained' color='primary' onClick={props.openDialog}>buttons.save</BottomPaddedButton>
    </>

  Buttons.propTypes = {
    arrRefs: PropTypes.array,
    openDialog: PropTypes.func,
  }

  const ButtonsForDialogBox = props =>
    <>
      <BottomPaddedButton color='primary' variant='outlined' onClick={closeGeneralDialog}>buttons.cancel</BottomPaddedButton>
      <SaveButton arrRefs={props.arrRefs} postService={props.postService} saveLabel={isNew ? 'buttons.saveNewTemplate' : 'buttons.saveTemplate'} />
    </>
  const ContentForDeleteBox = (props) => (
    <>
      <Label>Search.DeleteBoxContentTemp</Label>
      <Label>Search.DeleteBoxContent2</Label>
      <VerticalDivider />
    </>
  )
  const back = () => {
    if (location.state && location.state.state) {
      const stateDetail = location.state.state.detail
      history.push(`${routePaths.templateSearch}`, { isTitle: false, state: { detail: stateDetail } })
    } else {
      history.push(`${routePaths.templateSearch}`, { isTitle: false })
    }
  }
  const handleCalcelDeleteBox = () => {
    closeGeneralDialog()
  }

  const openDeleteBoxDialog = (rowdata) => {
    openGeneralDialog({
      title: t('Search.DeleteTemplate'),
      noTranslateTitle: true,
      message: <ContentForDeleteBox />,
      closeX: true,
      buttons: (
        <DeleteBox
          handleCancel={handleCalcelDeleteBox}
          handleDelete={() => handleDelete(rowdata)}
        />
      )
    })
    return Promise.resolve()
  }

  const DeleteBox = (props) => (
    <>
      <VerticalDivider />
      <XDivider width="35px" />
      <OutlinedButton id={'templateSearch_delete_cancel'} style={{ minWidth }} onClick={props.handleCancel} >Search.Cancel</OutlinedButton>
      <ContainedButton id={'templateSearch_delete_yes'} style={{ minWidth }} onClick={props.handleDelete}>Search.yes</ContainedButton>
      <XDivider width="35px" />
    </>
  )

  const handleDelete = (data) => {
    gdeTransactions.deleteTemplate(data)
      .then(() => {
        refLocalToast.current?.successToastOn({
          message: t('toast.Deleted')
        })
      })
    closeGeneralDialog()
  }
  const onSelecthandleDelete = async () => {
    const jobs = await gdeTransactions.getInProcessJobsForTemplate(location.pathname.substr(14))
    if (jobs.docs.length === 0) {
      openDeleteBoxDialog(location.pathname.substr(14))
    } else {
      openGeneralDialog({
        title: t('Search.DeleteTemplate'),
        message: t('templates.cannotDelete'),
        noTranslateTitle: true,
        noTranslateMessage: true,
        closeX: true
      })
    }
  }

  ButtonsForDialogBox.propTypes = {
    arrRefs: PropTypes.array,
    postService: PropTypes.func,
  }

  DeleteBox.propTypes = {
    handleCancel: PropTypes.func,
    handleDelete: PropTypes.func,
  }

  const SubTitleComponent = props =>
    <>
      <ArrowBack onClick={() => { back() }} cursor='pointer' />
      <XDivider width='10px' />
      {t('routeTitles.edittemplatedetails')}
      <XDivider width='10px' />
      <DeleteOutlined fontSize='small' onClick={onSelecthandleDelete} cursor='pointer' /></>

  const ContentForDialogBox = (props) => {
    return (
      <>
        <Label>{isNew ? t('messages.saveEditTemplateMessage') : t('messages.saveTemplateMessage')}</Label>
        <VerticalDivider />
        <TextField
          data={data}
          fieldTemplate={formTemplate[isNew ? FIELD_CUSTOM_TEMPLATE_NAME : FIELD_CUSTOM_TEMPLATE_NAME_OLD]}
          ref={arrRefs[isNew ? FIELD_CUSTOM_TEMPLATE_NAME : FIELD_CUSTOM_TEMPLATE_NAME_OLD]}
          noTranslateStartString
          startString={isNew ? getTemplateNamePrefix() : ''}
          disabled={!isNew}
          value={isNew ? '' : templateId}
          inputProps={isNew ? { maxLength: (60 - getTemplateNamePrefix().length) } : ''}
        />
      </>
    )
  }


  ContentForDialogBox.propTypes = {
    // namePrefix: PropTypes.func
  }

  const openDialog = async() => {
    openGeneralDialog({
      title: t('forms.saveTemplate'),
      noTranslateTitle: true,
      message: <ContentForDialogBox />,
      buttons: <ButtonsForDialogBox arrRefs={arrRefs} postService={postService} />,
      closeX: true,
      translateMessage: true
    })

    return Promise.resolve()
  }

  const getTemplatesForTemplateType = async (templateType, wms) => {
    const accLevel1 = arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue()
    const collection = await gdeTransactions.getTemplates(templateType, accLevel1)
    const useStandardTemplateOption = { value: useStandardTemplate, label: t('templates.useStandardTemplate') }
    const templateList = [defaultSelectOption, useStandardTemplateOption]
    const templateDetailsList = {}
    collection.forEach((doc) => {
      templateList.push({ value: doc.id, label: doc.id })
      templateDetailsList[doc.id] = doc
    })
    setState({ templates: templateDetailsList, templatesForSelect: templateList, selectedTemplate: '' })
  }

  // backend data conversion for template types
  state.templateTypeList.forEach((element, index) => {
    if (element.label !== '--Select--') {
      element.label = t(`templateTypeObj.${element.value}`)
    }
  })

  const onChangeTemplate = (value) => {
    if (value === undefined || value === constants.defaultSelect) {
      setState({ showTable: false })
    } else {
      if (value === useStandardTemplate) {
        title = getState().standardTemplates[arrRefs[SELECT_TEMPLATE_TYPE].current.getValue()].templateName
      } else {
        title = value
      }
      setState({ showTable: true, selectedTemplate: value })
    }
  }

  const onChangeTemplateType = (value) => {
    if (value !== undefined) {
      const selectedWms = arrRefs[SELECT_WMS].current.getValue()
      getTemplatesForTemplateType(value, selectedWms)
    }
  }

  const validateAccountLevel2 = (value) => {
    if (arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue() !== '') {
      validateAndGetAccountLevel2('AMER', arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue(), value)
        .then((result) => {
          if (result) {
            clearBusy()
            if (result.error) {
              arrRefs[SELECT_ACOUNT_LEVEL2].current.setErrorMsg(result.error, true)
            }
            if (result.success && result.statusCode === 200) {
              arrRefs[SELECT_ACOUNT_LEVEL2].current.clearErrorMsg()
              arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(false)
              arrRefs[SELECT_ACOUNT_LEVEL3].current.focus()
            }
          }
          clearBusy()

          arrRefs[SELECT_ACOUNT_LEVEL3].current.clear()
        })
    } else {
      arrRefs[SELECT_ACOUNT_LEVEL2].current.setErrorMsg('Select Account Level 1', true)
    }
  }


  const onChangeDivision = (e) => {
    const value = e?.target?.value
    if (e.keyCode === 13 && value !== '') {
      setBusy()
      validateAccountLevel2(value)
    }
  }

  const onBlurDivision = (e) => {
    arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
    e?.preventDefault()
    setBusy()
    validateAccountLevel2(e?.target?.value)
  }

  const validateAccountLevel3 = (value) => {
    if (arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue() !== '' && arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue() !== '') {
      validateAndGetAccountLevel3('AMER', arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue(), arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue(), value)
        .then((result) => {
          clearBusy()
          if (result.error) {
            arrRefs[SELECT_ACOUNT_LEVEL3].current.setErrorMsg(result.error, true)
          } else if (result.success && result.statusCode === 200) {
            arrRefs[SELECT_ACOUNT_LEVEL3].current.clearErrorMsg()
            arrRefs[SELECT_TEMPLATE_TYPE].current?.focus()
          }
        })
    } else {
      arrRefs[SELECT_ACOUNT_LEVEL3].current.setErrorMsg('Select Account Level 1 and 2', true)
    }
  }

  const onChangeDepartment = (e) => {
    const value = e?.target?.value
    if (e.keyCode === 13) {
      if (value) {
        setBusy()
        validateAccountLevel3(value)
      } else {
        arrRefs[SELECT_TEMPLATE_TYPE].current?.focus()
      }
    }
  }

  const onBlurDepartment = (e) => {
    e?.preventDefault()
    setBusy()
    validateAccountLevel3(e?.target?.value)
  }

  const getTemplateNamePrefix = () => {
    const selectFieldCountry = arrRefs[SELECT_COUNTRY].current.getValue()
    const selectFieldCustomer = arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue()
    const selectFieldDivision = arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue()
    const selectFieldDepartment = arrRefs[SELECT_ACOUNT_LEVEL3].current.getValue()

    const prefix = `${selectFieldCountry?.toUpperCase()}-${selectFieldCustomer?.toUpperCase()}-${selectFieldDivision ? `${selectFieldDivision?.toUpperCase()}-` : 'MASTER-'}${selectFieldDepartment ? `${selectFieldDepartment?.toUpperCase()}-` : 'MASTER-'}`
    return prefix
  }

  const postService = async postObject => {
    const customTemplateName = (getTemplateNamePrefix() + postObject.templateName).toUpperCase()
    if (Object.keys(getState().templates).includes(customTemplateName)) {
      arrRefs[FIELD_CUSTOM_TEMPLATE_NAME].current.setErrorMsg('templates.templateNameErrorMessage')
    } else {
      closeGeneralDialog()
      const arrPost = tableRef.current.dataManager.data
      const fields = {}
      let costomOrder = 1
      arrPost.forEach(r => {
        if (r.tableData.checked) {
          delete r.rowSelected
          delete r.tableData
          const fieldName = r.name
          delete r.name
          delete r.isRequiredChanged
          r.customOrder = costomOrder
          costomOrder++
          fields[fieldName] = r
        }
      })

      const templateData = {
        countryCode: postObject.country,
        wmsCode: postObject.associatedWMSSystem,
        accountLevel1: postObject.accountLevel1?.toUpperCase(),
        accountLevel2: postObject.accountLevel2 ? postObject?.accountLevel2?.toUpperCase() : '',
        accountLevel3: postObject.accountLevel3 ? postObject?.accountLevel3?.toUpperCase() : '',
        dataEntryType: postObject.dataEntryType,
        templateType: state.templateData.templateType,
        standardTemplateName: state.templateData.standardTemplateName,
        templateName: isNew ? customTemplateName : templateId,
        templateFields: fields,
        lastUsed: new Date(),
        templateInstructions: getState().changeTemplateInstructions || getState().existingTemplateInstructions || '',
      }

      if (isNew) {
        // create new template when template associated with jobs with status 'complete' and 'in progress'
        gdeTransactions.createTemplate(templateData)
          .then(() => {
            refLocalToast.current?.successToastOn({
              message: t('toast.templateCreatedSuccessfully',
                { templateName: customTemplateName }),
              title: t('toast.templateCreationTitle'),
              noTranslateMessage: true,
              noTranslateTitle: true
            })
            setTimeout(() => {
              back()
            }, 3000)
          })
      } else {
        // To override existing template 
        gdeTransactions.updateTemplate(templateId, templateData)
          .then(() => {
            refLocalToast.current?.successToastOn({
              message: t('toast.yourChangesSaved')
            })
            setTimeout(() => {
              back()
            }, 3000)
          })
      }
      clearBusy()
    }
  }

  const handleAddInst = () => {
    openGeneralDialog({
      title: t('forms.enterInstructions'),
      message: <ContentforInstructionsBox />,
      buttons: <ButtonsforInstructionBox />,
      noTranslateTitle: true,
    })
  }

  const ContentforInstructionsBox = () => {
    return (
      <TextareaAutosize
        aria-label="empty textarea"
        placeholder= {t('forms.enterInstructions')}
        label= {t('forms.enterInstructions')}
        style={{ width: 500, height: 50 }}
        onBlur={(e) => setState({ templateInstructions: e.target.value })}
        defaultValue={getState().existingTemplateInstructions || getState().changeTemplateInstructions}
      />
    )
  }

  const ButtonsforInstructionBox = () => {
    return (
      <>
        <BottomPaddedButton color='primary' variant='outlined' onClick={closeGeneralDialog}>buttons.cancel</BottomPaddedButton>
        <BottomPaddedButton color='primary' variant='contained' onClick={handleInstructionsSave}>buttons.save</BottomPaddedButton>
      </>
    )
  }

  const deactivateTemplate = async (evt) => {
    const isActiveKey = {
      // eslint-disable-next-line
      isActive: evt === true ? false : true
    }
    await gdeTransactions.updateTemplate(templateId, isActiveKey)
    if (evt) {
      successToast({ message: t('toast.templateDeactivated'), autoHideDuration: 2000 })
    } else {
      successToast({ message: t('toast.templateActivated'), autoHideDuration: 2000 })
    }
    closeGeneralDialog()
    back()
  }

  const closeDe = () => {
    setIsTemplateDeactivated(isTemplateDeactivated)
    closeGeneralDialog()
  }

  const ButtonsForDeactivateTemplate = (props) => {
    return (
      <>
        <OutlinedButton onClick={closeDe}>buttons.no</OutlinedButton>
        <ContainedButton onClick = {() => deactivateTemplate(props.evt)}>buttons.yes</ContainedButton>
      </>
    )
  }

  ButtonsForDeactivateTemplate.propTypes = {
    evt: PropTypes.any
  }

  const handleDeactivateTemplate = (evt) => {
    setIsTemplateDeactivated(evt)
    openGeneralDialog({
      message: getState().checkTemplateDeactivated ? t('messages.activateTemplateConfirmation') : t('messages.deactivateTemplateConfirmation'),
      buttons: <ButtonsForDeactivateTemplate evt={evt} />
    })
  }

  const openAddCustomFieldsDialog = () => {
    saveStandardTemplateValues()
    saveTemplateFieldNames()
    setOpen(true)
    setState({ openCustomFieldsDialog: true, showTable: false })
  }

  const saveStandardTemplateValues = () => { 
    const fields = getState().standardTemplates[arrRefs[SELECT_TEMPLATE_TYPE].current.getValue()].templateFields
    const arrayFields = Object.keys(fields).map((key) => {
      const data = fields[key]
      data.name = key
      return data
    })
    arrayFields.sort((a, b) =>
      a.customOrder > b.customOrder ? 1 : b.customOrder > a.customOrder ? -1 : 0
    )
    setState({ saveStandardTempValues: arrayFields })
  }

  //  saves custom templateFields
  const saveTemplateFieldNames = () => {
    const selectedCustomTemplateFieldNames = []
    getState().selectedTemplateFields.map((field) => {
      return selectedCustomTemplateFieldNames.push(field.name)
    })
    setState({
      selectedTemplateFieldNames: selectedCustomTemplateFieldNames
    })
  }

  const handleClose = () => {
    setOpen(false)
    setState({ showTable: true })
  }

  let selectedFields = []

  const handleCheckBox = (e, field) => {
    e && selectedFields.push(field)
    if (e === false) {
      selectedFields = reject(selectedFields, (f) => f.name === field.name)
    }
  }

  const closeAddCustomFieldsDialog = () => {
    setState({ showTable: true })
    setState({ openCustomFieldsDialog: false })
  }

  const handleSaveCustomFields = () => {
    let savedFields = []
    savedFields = selectedFields.concat(getState().selectedTemplateFields)
    setState({
      addedCustomFields: savedFields,
      showTable: true,
      renderNewTemplate: true,
      isCustomFieldsAdded: true
    })
    setIsNew(false)
    getTableData()
    setState({ openCustomFieldsDialog: false, enableAddFieldsBtn: false })
  }

  const closeResetFields = () => {
    setState({ showTable: true })
    closeGeneralDialog()
  }

  const confirmResetFields = async() => {
    setState({ renderNewTemplate: false, isCustomFieldsAdded: false })
    getTableData()
    setState({ showTable: true, enableAddFieldsBtn: true })
    const jobsForTemplate = await gdeTransactions.getJobsForTemplate(getState()?.fieldKey, templateId)
    let requiredNew = false
    jobsForTemplate.forEach((doc) => {
      if ((doc.data().jobStatus === constants.jobStatus.inProgress || doc.data().jobStatus === constants.jobStatus.approved || doc.data().jobStatus === constants.jobStatus.transmitted) && (!getState()?.renderNewTemplate)) {
        requiredNew = true
      }
    })
    setIsNew(requiredNew)
    closeGeneralDialog()
  }

  const ButtonsForResetFields = () => {
    return (
      <>
        <OutlinedButton onClick={closeResetFields}>buttons.no</OutlinedButton>
        <ContainedButton onClick={confirmResetFields}>
          buttons.yes
        </ContainedButton>
      </>
    )
  }


  const resetFields = () => {
    setState({ showTable: false })
    openGeneralDialog({
      title: t('options.resetField'),
      message: t('options.resetFields'),
      noTranslate: true,
      noTranslateTitle: true,
      buttons: <ButtonsForResetFields />,
      closeX: false
    })
  }



  return (
    <>
      <MainRouteSubRoutePage
        mainTitle='routeTitles.templateManagement'
        subTitle={<SubTitleComponent />}
        buttons={disableState ? '' : <Buttons arrRefs={arrRefs} postService={postService} openDialog={openDialog} />}
      >
        <FlexByRow>
          <LocalToast ref={refLocalToast} />
          <HalfScreen>
            <Select
              id={'editTemplate_country'}
              data={data}
              items={state.countryList}
              fieldTemplate={formTemplate[SELECT_COUNTRY]}
              ref={arrRefs[SELECT_COUNTRY]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
            <Select
              id={'editJob_skpInstance'}
              data={data}
              items={state.skpInstance}
              fieldTemplate={formTemplate[SKP_INSTANCE]}
              ref={arrRefs[SKP_INSTANCE]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
            <Select
              id={'editTemplate_wms'}
              data={data}
              items={state.wmsList}
              fieldTemplate={formTemplate[SELECT_WMS]}
              ref={arrRefs[SELECT_WMS]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
            <TextField
              id={'editTemplate_accountLevel1'}
              data={data}
              fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL1]}
              ref={arrRefs[SELECT_ACOUNT_LEVEL1]}
              disabled={true}
            />
            <VerticalDivider />
            <TextField
              id={'editTemplate_division'}
              onKeyDown={(e) => onChangeDivision(e)}
              onBlur={(e) => onBlurDivision(e)}
              data={data}
              fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL2]}
              ref={arrRefs[SELECT_ACOUNT_LEVEL2]}
              disabled={disableState}
            />
          </HalfScreen>
          <XDivider width='50px' />
          <HalfScreen>
            <TextField
              id={'editTemplate_accounlevel3'}
              onKeyDown={(e) => onChangeDepartment(e)}
              onBlur={(e) => onBlurDepartment(e)}
              data={data}
              fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL3]}
              ref={arrRefs[SELECT_ACOUNT_LEVEL3]}
              disabled={disableState}
            />
            <VerticalDivider />
            <Select
              id={'editTemplate_templateType'}
              onChange={onChangeTemplateType}
              data={data}
              items={state.templateTypeList}
              fieldTemplate={formTemplate[SELECT_TEMPLATE_TYPE]}
              ref={arrRefs[SELECT_TEMPLATE_TYPE]}
              noTranslateItems
              disabled={disableState}
            />
            <VerticalDivider />
            <Select
              id={'editTemplate_templateName'}
              data={data}
              items={state.templatesForSelect}
              fieldTemplate={formTemplate[SELECT_TEMPLATE_NAME]}
              ref={arrRefs[SELECT_TEMPLATE_NAME]}
              disabled={disableState}
              onChange={onChangeTemplate}
              noTranslateItems
            />
            <VerticalDivider />
            <CheckBox label={t('demo.deactivate')} noTranslate disabled={!getState().showDeactivateTemplateCheckBox} onChange={(evt) => handleDeactivateTemplate(evt)} checked={isTemplateDeactivated} />
            <ToolTip
              message='demo.deactivateTemplate'
              style={{ height: '21px' }}
            ><Info />
            </ToolTip>

            <YDivider height="10px" />
            <OutlinedButton onClick={handleAddInst}>buttons.addInstructions</OutlinedButton>
            <YDivider height="10px" />
          </HalfScreen>
        </FlexByRow>
        {state.showTable
          ? <>
            <VerticalDivider />
            <TemplateFormat tableRef={tableRef} getState={getState} skpEncoding={getState()?.skpEncoding} setState={setState} getPageData={getTableData} title={title} formTemplates={formTemplate} arrRefs={arrRefs} isEdit={false} />
          </>
          : null
        }
        {getState().selectedTemplate !== useStandardTemplate &&
                getState().enableAddFieldsBtn && (
                  <ContainedButton
                    disabled={isDataEntryUser()}
                    onClick={openAddCustomFieldsDialog}
                    style={{ float: 'right', marginRight: '8px' }}
                  >
                    buttons.addFields
                  </ContainedButton>
        )}
        {getState().openCustomFieldsDialog && (
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>{t('buttons.addFields')}</DialogTitle>
          <DialogContent style={{ width: '300px', height: 'auto' }}>
            <Grid container spacing={10}>
              <Grid item xs={5}>
                {getState().saveStandardTempValues.map((field) => {
                  return (
                    field.isSelected &&
                      !getState().selectedTemplateFieldNames.includes(
                        field.name
                      ) && (
                        <>
                          <CheckBox
                            label={field.name}
                            noTranslate
                            onChange={(e) => handleCheckBox(e, field)}
                          />
                        </>
                    )
                  )
                })}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <OutlinedButton onClick={closeAddCustomFieldsDialog}>
              buttons.cancel
            </OutlinedButton>
            <ContainedButton onClick={handleSaveCustomFields}>
              buttons.save
            </ContainedButton>
          </DialogActions>
        </Dialog>
        )}
        {getState().isCustomFieldsAdded && (
        <>
          <OutlinedButton
            onClick={resetFields}
            style={{ float: 'right', marginRight: '8px' }}
                  >
            buttons.resetFields
          </OutlinedButton>
        </>
        )}
      </MainRouteSubRoutePage>
    </>
  )
}

export default EditTemplate